"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const ColumnToggleOptionsContainer_1 = require("../../styled/ColumnToggleOptionsContainer");
const lodash_1 = __importDefault(require("lodash"));
exports.ColumnToggle = ({ columns, onChangeFilterColumns, }) => {
    const [isOpen, setIsOpen] = react_1.useState(false);
    const handleChange = (e) => {
        let { name: colId } = e.target;
        const col = columns.find((x) => x.id === colId);
        const colIndex = columns.findIndex((x) => x.id === colId);
        if (col) {
            col.hidden = !col.hidden;
            const f = lodash_1.default.cloneDeep(columns);
            f[colIndex] = col;
            onChangeFilterColumns(f);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "mx-2", onClick: () => setIsOpen(true) },
            react_1.default.createElement("i", { className: "fa fa-cog cursor-pointer" })),
        react_1.default.createElement(reactstrap_1.Modal, { isOpen: isOpen, toggle: () => setIsOpen(false), ali: true },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => setIsOpen(false) },
                react_1.default.createElement("div", { className: "d-flex w-100 justify-content-between align-items-center" },
                    react_1.default.createElement("div", null, "Select Columns"))),
            react_1.default.createElement(reactstrap_1.ModalBody, null,
                react_1.default.createElement(reactstrap_1.Container, null,
                    react_1.default.createElement(reactstrap_1.Row, null,
                        react_1.default.createElement(reactstrap_1.Col, null,
                            react_1.default.createElement(ColumnToggleOptionsContainer_1.ColumnToggleOptionsContainer, null, columns.map((col) => {
                                const checked = !col.hidden;
                                return (react_1.default.createElement("div", { className: "d-flex align-items-center" },
                                    react_1.default.createElement("input", { type: "checkbox", name: col.id, checked: checked, onChange: handleChange }),
                                    react_1.default.createElement(reactstrap_1.Label, { className: "ml-3" },
                                        " ",
                                        col.name,
                                        " ")));
                            })))))))));
};
//# sourceMappingURL=ColumnToggle.js.map